import { ReactComponent as AoosLogoWhite } from '../../assets/aoos-logo-white.svg'

export const Logo = () => (
    <AoosLogoWhite height="40" width="106" />
)
